<script setup>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router' // Importiere den Router, um zur Login-Seite zu navigieren
import { useColorModes } from '@coreui/vue'
import AppBreadcrumb from '@/components/AppBreadcrumb.vue'
import { useSidebarStore } from '@/stores/sidebar.js'

const headerClassNames = ref('p-0')
const { colorMode, setColorMode } = useColorModes('coreui-free-vue-admin-template-theme')
const sidebar = useSidebarStore()
const router = useRouter() // Definiere den Router für Navigation
const isAuthenticated = ref(false) // Zustand, der den Login-Status verfolgt

// Prüfe beim Laden der Seite, ob der Benutzer authentifiziert ist
onMounted(() => {
  // Wenn ein Token vorhanden ist, gehe davon aus, dass der Benutzer eingeloggt ist
  isAuthenticated.value = !!localStorage.getItem('accessToken')

  document.addEventListener('scroll', () => {
    if (document.documentElement.scrollTop > 0) {
      headerClassNames.value = 'p-0 shadow-sm'
    } else {
      headerClassNames.value = 'p-0'
    }
  })
})

// Funktion für Logout
const logout = () => {
  localStorage.removeItem('accessToken')
  localStorage.removeItem('refreshToken')
  localStorage.removeItem('isSuperuser')
  isAuthenticated.value = false
  // Seite aktualisieren und zur Login-Seite weiterleiten
  router.push('/').then(() => {
    window.location.reload();
  });
}

// Funktion für Login
const goToLogin = () => {
  router.push('/pages/login') // Navigiert zur Login-Seite
}

// Funktion für Login
const changePW = () => {
  router.push('/pages/change-pw') // Navigiert zur Login-Seite
}
</script>


<template>
  <CHeader position="sticky" :class="headerClassNames">
    <CContainer class="border-bottom px-4" fluid>
      <CHeaderToggler @click="sidebar.toggleVisible()" style="margin-inline-start: -14px">
        <CIcon icon="cil-menu" size="lg" />
      </CHeaderToggler>
      <CHeaderNav class="d-none d-md-flex">
        <CNavItem>
          <CNavLink href="/"> CMI IQ Pro+ (Skywalker) </CNavLink>
        </CNavItem>
      </CHeaderNav>
      <CHeaderNav class="ms-auto d-none d-md-flex">
        <!-- <CNavItem>
          <CNavLink href="#">
            <CIcon icon="cil-bell" size="lg" />
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink href="#">
            <CIcon icon="cil-list" size="lg" />
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink href="#">
            <CIcon icon="cil-envelope-open" size="lg" />
          </CNavLink>
        </CNavItem> -->
      </CHeaderNav>
      <CHeaderNav>
        <li class="nav-item py-1 d-none d-md-flex">
          <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
        </li>
        <CDropdown variant="nav-item" placement="bottom-end">
          <CDropdownToggle :caret="false">
            <CIcon v-if="colorMode === 'dark'" icon="cil-moon" size="lg" />
            <CIcon v-else-if="colorMode === 'light'" icon="cil-sun" size="lg" />
            <CIcon v-else icon="cil-contrast" size="lg" />
          </CDropdownToggle>
          <CDropdownMenu>
            <CDropdownItem
              :active="colorMode === 'light'"
              class="d-flex align-items-center"
              component="button"
              type="button"
              @click="setColorMode('light')"
            >
              <CIcon class="me-2" icon="cil-sun" size="lg" /> Light
            </CDropdownItem>
            <CDropdownItem
              :active="colorMode === 'dark'"
              class="d-flex align-items-center"
              component="button"
              type="button"
              @click="setColorMode('dark')"
            >
              <CIcon class="me-2" icon="cil-moon" size="lg" /> Dark
            </CDropdownItem>
            <CDropdownItem
              :active="colorMode === 'auto'"
              class="d-flex align-items-center"
              component="button"
              type="button"
              @click="setColorMode('auto')"
            >
              <CIcon class="me-2" icon="cil-contrast" size="lg" /> Auto
            </CDropdownItem>
          </CDropdownMenu>
        </CDropdown>
        <li class="nav-item py-1 d-none d-md-flex">
          <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
        </li>

        <!-- Zeige Login/Logout basierend auf dem Authentifizierungsstatus -->
        <CNavItem v-if="!isAuthenticated">
          <CButton color="primary" style="color: #FFFFFF;" @click="goToLogin">Login</CButton>
        </CNavItem>

        <!-- Logout-Button, wenn authentifiziert -->
        <CNavItem v-if="isAuthenticated">
          <CButton color="outline-primary mx-3" @click="changePW">Passwort ändern</CButton>
        </CNavItem>
        <CNavItem v-if="isAuthenticated">
          <CButton color="primary" style="color: #FFFFFF;" @click="logout">Logout</CButton>
        </CNavItem>
      </CHeaderNav>
    </CContainer>
  </CHeader>
</template>
